import Swiper from "swiper/bundle";
import "swiper/css/bundle";

(function ($) {
  "use strict";

  $(function () {
    var recent_tx = new Swiper(".recent_tx", {
      slidesPerView: 1,
      grabCursor: true,
      speed: 5000,
      spaceBetween: 30,
      freeMode: true,
      loop: true,
      loopAddBlankSlides: true,
      centeredSlides: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
      },
    });

    var timeline = new Swiper(".-timeline", {
      slidesPerView: 2,
      grabCursor: true,
      navigation: {
        nextEl: ".-next",
        prevEl: ".-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });

    var tombstones = new Swiper(".tombstones-swiper", {
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".-next",
        prevEl: ".-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });

    var homepageTestimonials = new Swiper(".homepage-testimonials-swiper", {
      slidesPerView: "auto",
      grabCursor: true,
      spaceBetween: 20,
      loop: true,
      autoHeight: false, // Disable auto height to allow equal heights
      navigation: {
        nextEl: ".homepage-testimonials__nav-btn--next",
        prevEl: ".homepage-testimonials__nav-btn--prev",
      },
      on: {
        init: function() {
          // Set equal heights for all slides after initialization
          setEqualSlideHeights();
        },
        slideChange: function() {
          // Update heights when slides change (for loop mode)
          setTimeout(setEqualSlideHeights, 100);
        },
        resize: function() {
          // Update heights on resize
          setEqualSlideHeights();
        },
      },
    });

    // Function to set equal heights for all testimonial slides
    function setEqualSlideHeights() {
      var swiper = document.querySelector(".homepage-testimonials-swiper");
      if (!swiper) return;

      // Get all slides, including duplicates for loop mode
      var allSlides = swiper.querySelectorAll(".swiper-slide");
      if (allSlides.length === 0) return;

      // Get unique slides (non-duplicates) to calculate max height
      var uniqueSlides = Array.from(allSlides).filter(function(slide) {
        return !slide.classList.contains("swiper-slide-duplicate");
      });

      if (uniqueSlides.length === 0) return;

      // Reset heights to auto to get natural heights
      allSlides.forEach(function(slide) {
        slide.style.height = "auto";
      });

      // Force a reflow to ensure heights are calculated
      swiper.offsetHeight;

      // Find the tallest slide from unique slides
      var maxHeight = 0;
      uniqueSlides.forEach(function(slide) {
        var slideHeight = slide.offsetHeight;
        if (slideHeight > maxHeight) {
          maxHeight = slideHeight;
        }
      });

      // Set all slides (including duplicates) to the same height
      if (maxHeight > 0) {
        allSlides.forEach(function(slide) {
          slide.style.height = maxHeight + "px";
        });
      }
    }
  });
})(jQuery);
